import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";


export default function Header(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [activeMenu, setActiveMenu] = useState("Home"); // Track active menu item
  const [showLoginPopup, setShowLoginPopup] = useState(false);


  const location = useLocation();
  const history = useHistory();
  /* ---------- SET ACTIVE MENU BASED ON URL ---------- */
  // useEffect(() => {
  //   const path = location.pathname;

  //   if (path === "/") {
  //     setActiveMenu("Home");
  //   } else if (path === "/listing") {
  //     setActiveMenu("Sell");
  //   } else if (path === "/gold-price") {
  //     setActiveMenu("Gold");
  //   } else if (path === "/silver-price") {
  //     setActiveMenu("Silver");
  //   } else if (path === "/contact") {
  //     setActiveMenu("Contact");
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const path = location.pathname;

    if (path === "/") {
      setActiveMenu("Home");
    }
    else if (
      path.includes("/sell-product")
      // path.includes("/sell-product") ||
      // path.includes("/list-product")
    ) {
      setActiveMenu("Sell");
    } else if (path.includes("/listing")) {
      setActiveMenu("List");
    } else if (path.includes("/price")) {
      setActiveMenu("Gold");
    }
    // else if (path.includes("/price")) {
    //   setActiveMenu("Silver");
    // }
    else if (path.includes("/contact")) {
      setActiveMenu("Contact");
    }
    else {
      setActiveMenu(""); // ✅ reset when no match
    }
  }, [location.pathname]);

  /* ---------- LOGIN CHECK ---------- */
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        jwtDecode(token);
        setIsLoggedIn(true);
      } catch {
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);


  useEffect(() => {
    // Every time URL changes, close mobile menu and restore scroll
    setMenuOpen(false); // close sidebar
    document.body.classList.remove("sideMenu"); // remove freeze
    document.body.style.overflow = ""; // allow scrolling
    document.body.style.position = ""; // reset position if CSS used fixed
  }, [location.pathname]); // runs when the page changes

  const openSearch = (e) => {
    e.preventDefault();
    document.body.classList.toggle("openSerch");
  };

  const closeSearch = (e) => {
    e.preventDefault();
    document.body.classList.remove("openSerch");
  };



  /* ---------- SCREEN SIZE DETECT ---------- */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      // remove mobile menu when switching to desktop
      if (!mobile) {
        setMenuOpen(false);
        document.body.classList.remove("sideMenu");
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------- FIXED HEADER SCROLL ---------- */
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".headersec");
      if (!header) return;

      if (window.scrollY > 50) {
        header.classList.add("fixed_header");
      } else {
        header.classList.remove("fixed_header");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ---------- MENU TOGGLE ---------- */
  const toggleMenu = () => {
    const newState = !menuOpen;
    setMenuOpen(newState);

    if (newState) {
      document.body.classList.add("sideMenu");
      document.body.style.overflow = "hidden"; // prevent background scroll
      document.body.style.position = "fixed";  // optional for some devices
    } else {
      document.body.classList.remove("sideMenu");
      document.body.style.overflow = "";
      document.body.style.position = "";
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.classList.remove("sideMenu");
    document.body.style.overflow = "";
    document.body.style.position = "";
  };

  /* ---------- HANDLE MENU CLICK ---------- */
  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName); // Set active menu
    if (isMobile) {
      closeMenu(); // Close sidebar on mobile
    }
  };

  /* ---------- LOGOUT ---------- */
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    setIsLoggedIn(false);
    // window.location.reload();
    history.push("/");
  };

  const handleWishlistClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault(); // stop navigation
      setShowLoginPopup(true); // open popup
    }
  };

  return (
    <>
      <header className="headersec">
        {/* OVERLAY */}
        {menuOpen && <div className="menuOvrly" onClick={closeMenu}></div>}

        {/* CLOSE BUTTON */}
        {menuOpen && (
          <a href="javascript:void(0)" className="closeMenu" onClick={closeMenu}></a>
        )}

        {!isMobile && (
          <div className="hdertop">
            <div className="container">
              <span>
                Download the JWLBOOK APP
                <a href="https://play.google.com/store/apps/details?id=com.jwlbookllc.jwlbook" target="_blank" rel="noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-android2" viewBox="0 0 16 16">
                    <path d="m10.213 1.471.691-1.26q.069-.124-.048-.192-.128-.057-.195.058l-.7 1.27A4.8 4.8 0 0 0 8.005.941q-1.032 0-1.956.404l-.7-1.27Q5.281-.037 5.154.02q-.117.069-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.7 3.7 0 0 0 3.5 5.02h9q0-1.125-.623-2.072a4.27 4.27 0 0 0-1.664-1.476ZM6.22 3.303a.37.37 0 0 1-.267.11.35.35 0 0 1-.263-.11.37.37 0 0 1-.107-.264.37.37 0 0 1 .107-.265.35.35 0 0 1 .263-.11q.155 0 .267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264m4.101 0a.35.35 0 0 1-.262.11.37.37 0 0 1-.268-.11.36.36 0 0 1-.112-.264q0-.154.112-.265a.37.37 0 0 1 .268-.11q.155 0 .262.11a.37.37 0 0 1 .107.265q0 .153-.107.264M3.5 11.77q0 .441.311.75.311.306.76.307h.758l.01 2.182q0 .414.292.703a.96.96 0 0 0 .7.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182q0 .414.292.703a.97.97 0 0 0 .71.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76q.436 0 .749-.308.31-.307.311-.75V5.365h-9zm10.495-6.587a.98.98 0 0 0-.702.278.9.9 0 0 0-.293.685v4.063q0 .406.293.69a.97.97 0 0 0 .702.284q.42 0 .712-.284a.92.92 0 0 0 .293-.69V6.146a.9.9 0 0 0-.293-.685 1 1 0 0 0-.712-.278m-12.702.283a1 1 0 0 1 .712-.283q.41 0 .702.283a.9.9 0 0 1 .293.68v4.063a.93.93 0 0 1-.288.69.97.97 0 0 1-.707.284 1 1 0 0 1-.712-.284.92.92 0 0 1-.293-.69V6.146q0-.396.293-.68" />
                  </svg>
                </a>
                <a href="https://apps.apple.com/us/app/jwlbook-jewelry/id6744888223" target="_blank" rel="noreferrer" className="apple">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                    <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                  </svg>
                </a>
              </span>
            </div>
          </div>
        )}

        {isMobile && (
          <div className="hdertop">
            <div className="container hdertop-flex">

              {/* <img style={{height: '25px', width: '25px'}} src={`${process.env.PUBLIC_URL}/favicon.png`} alt="" /> */}

              <span className="hdertop-text d-flex w-100 flex-row justify-content-between">
                <span>
                  <a href="https://play.google.com/store/apps/details?id=com.jwlbookllc.jwlbook" target="_blank" rel="noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-android2" viewBox="0 0 16 16">
                      <path d="m10.213 1.471.691-1.26q.069-.124-.048-.192-.128-.057-.195.058l-.7 1.27A4.8 4.8 0 0 0 8.005.941q-1.032 0-1.956.404l-.7-1.27Q5.281-.037 5.154.02q-.117.069-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.7 3.7 0 0 0 3.5 5.02h9q0-1.125-.623-2.072a4.27 4.27 0 0 0-1.664-1.476ZM6.22 3.303a.37.37 0 0 1-.267.11.35.35 0 0 1-.263-.11.37.37 0 0 1-.107-.264.37.37 0 0 1 .107-.265.35.35 0 0 1 .263-.11q.155 0 .267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264m4.101 0a.35.35 0 0 1-.262.11.37.37 0 0 1-.268-.11.36.36 0 0 1-.112-.264q0-.154.112-.265a.37.37 0 0 1 .268-.11q.155 0 .262.11a.37.37 0 0 1 .107.265q0 .153-.107.264M3.5 11.77q0 .441.311.75.311.306.76.307h.758l.01 2.182q0 .414.292.703a.96.96 0 0 0 .7.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182q0 .414.292.703a.97.97 0 0 0 .71.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76q.436 0 .749-.308.31-.307.311-.75V5.365h-9zm10.495-6.587a.98.98 0 0 0-.702.278.9.9 0 0 0-.293.685v4.063q0 .406.293.69a.97.97 0 0 0 .702.284q.42 0 .712-.284a.92.92 0 0 0 .293-.69V6.146a.9.9 0 0 0-.293-.685 1 1 0 0 0-.712-.278m-12.702.283a1 1 0 0 1 .712-.283q.41 0 .702.283a.9.9 0 0 1 .293.68v4.063a.93.93 0 0 1-.288.69.97.97 0 0 1-.707.284 1 1 0 0 1-.712-.284.92.92 0 0 1-.293-.69V6.146q0-.396.293-.68" />
                    </svg>
                  </a>
                  Android
                </span>
                Download the JWLBOOK APP
                <span>

                  <a href="https://apps.apple.com/us/app/jwlbook-jewelry/id6744888223" target="_blank" rel="noreferrer" className="apple">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                    </svg>
                  </a>
                  Apple
                </span>

                {/* <span className="mobile-text">
          Open in the jwl.com app
        </span> */}
              </span>

              {/* <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noreferrer"
                className="viewBtn"
              >
                Open
              </a> */}

            </div>
          </div>
        )}

        <div className="container">
          <div className="hderinr">
            {/* LOGO */}
            <div className="hdrlgo">
              <Link to="/">
                <img src={`${process.env.PUBLIC_URL}/assets/images/hderlgo.png`} alt="" />
              </Link>
            </div>

            {/* MENU */}
            <div className="hdrmnu">
              {/* MOBILE HAMBURGER */}
              {isMobile && (
                <div className="menu-collapser">
                  <div className="collapse-button" onClick={toggleMenu}>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </div>
                </div>
              )}

              {/* MENU LIST */}
              <ul className={`slimmenu ${isMobile && !menuOpen ? "collapsed" : ""}`}>
                <li
                  className={activeMenu === "Home" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("Home")}
                >
                  <Link to="/">Home</Link>
                </li>

                <li
                  className={activeMenu === "List" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("List")}
                >
                  <Link to="/listing">Listing</Link>
                </li>

                <li
                  className={activeMenu === "Sell" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("Sell")}
                >
                  {isLoggedIn ? (
                    <Link to="/sell-product">Sell Your Jewelry</Link>
                  ) : (
                    <Link to="/login">Sell Your Jewelry</Link>
                  )}
                  {/* <Link to="/listing">Listing</Link> */}
                </li>

                <li
                  className={activeMenu === "Gold" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("Gold")}
                >
                  <Link to="/price">Prices</Link>
                </li>

                {/* <li
                  className={activeMenu === "Silver" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("Silver")}
                >
                  <Link to="/silver-price">Silver Prices</Link>
                </li> */}

                <li
                  className={activeMenu === "Contact" ? "current-menu-item" : ""}
                  onClick={() => handleMenuClick("Contact")}
                >
                  <Link to="/contact">Contact Us</Link>
                </li>

                {/* {isLoggedIn && (
                  <li onClick={() => handleMenuClick("Logout")}>
                    <Link to="#" onClick={handleLogout}>
                      Logout
                    </Link>
                  </li>
                )} */}
              </ul>
            </div>

            {/* RIGHT ICONS */}
            <div className="hderrght">
              <ul>
                <li>
                  <Link to={isLoggedIn ? "/dashboard" : "/login"}>
                    <img src={`${process.env.PUBLIC_URL}/assets/images/user.svg`} alt="" />
                  </Link>
                </li>

                {/* <li>
                  <Link to="/list-wishlist" onClick={handleWishlistClick}>
                    <img src={`${process.env.PUBLIC_URL}/assets/images/heart.svg`} alt="" />
                  </Link>
                </li> */}

                {/* <li>
                  <Link to="#">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/cart.svg`} alt="" />
                  </Link>
                </li> */}

                {/* {isLoggedIn && (
                  <li>
                    <Link to="#" onClick={handleLogout}>

                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                        <path d="M12 2v10" />
                        <path d="M6.2 6.2a8 8 0 1 0 11.6 0" />
                      </svg>
                      Logout
                    </Link>
                  </li>
                )} */}

                {isLoggedIn && (
                  <span style={{ width: "80px" }}>
                    <Link
                      to="#"
                      onClick={handleLogout}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <img style={{ height: "26px", width: "26px" }} src={`${process.env.PUBLIC_URL}/assets/images/power-off.png`} alt="" />
                      <span style={{ whiteSpace: "nowrap", textDecoration: "none", color: "#000", fontSize: "17px" }}>Logout</span>
                    </Link>
                  </span>
                )}


              </ul>
            </div>
          </div>
        </div>
      </header>

      <div className="fixedSerch">
        <div className="fixedSerchinr">
          <a href="#" className="closeSrch" onClick={closeSearch}>
            <img src={`${process.env.PUBLIC_URL}/assets/images/close.png`} alt="" />
          </a>

          <input type="search" placeholder="Search..." />
          <input type="submit" value="" />
        </div>
      </div>

      <div className="mobilehder">
        <ul>
          <li>
            <Link to="/">
              <i>
                <img src={`${process.env.PUBLIC_URL}/assets/images/mobileHder1.svg`} alt="" />
              </i>
              Home
            </Link>
          </li>
          <li>
            <Link to={isLoggedIn ? "/dashboard" : "/login"}>
              <i>
                <img src={`${process.env.PUBLIC_URL}/assets/images/mobileHder2.svg`} alt="" />
              </i>
              Account
            </Link>
          </li>
          <li style={{ lineHeight: "10px" }}>
            <Link to="/price">
              <i>
                <img style={{ width: "20px", height: "20px" }} src={`${process.env.PUBLIC_URL}/assets/images/price1.png`} alt="" />
              </i>
              Price
            </Link>
          </li>
          <li>
            <Link to={isLoggedIn ? "/sell-product" : "/login"}>
              <i>
                <img style={{ width: "20px", height: "20px" }} src={`${process.env.PUBLIC_URL}/assets/images/add.png`} alt="" />
              </i>
              Add
            </Link>
          </li>
        </ul>
      </div>
      {showLoginPopup && (
        <div className="customModalOverlay">
          <div className="customModalBox">

            {/* ICON */}
            <div className="customModalIcon">
              !
            </div>

            {/* TITLE */}
            <h2>Login Required</h2>

            {/* MESSAGE */}
            <p>Please login to chat with the seller.</p>

            {/* BUTTON */}
            <button
              className="customModalBtn"
              onClick={() => {
                setShowLoginPopup(false);
                history.push("/login");
              }}
            >
              OK
            </button>

          </div>
        </div>
      )}
    </>
  );
}

Header.propTypes = {
  home: PropTypes.string,
  aboutText: PropTypes.number,
};